import { Text, View } from '@react-pdf/renderer';

import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { styles } from '../../styles';
import { stylesAwesome } from '@composites/PDF/AgendaPdfContent/components/EventAtGlance';
import { useTranslation } from 'react-i18next';

interface PartnerDetailsProps {
  event: PublicEventDetailsResponse;
}

const PartnerDetails = ({ event }: PartnerDetailsProps) => {
  const { t } = useTranslation();
  return (
    <View>
      <View
        style={{
          ...styles.rightSideBody,
          gap: 20,
          flex: '0 0 33%',
          justifyContent: 'flex-end',
          alignItems: 'flex-start',
          paddingBottom: 70,
        }}
      >
        <View>
          <Text style={styles.bodyTitle}>{t('prospectus-title-13')}</Text>
        </View>
        <View style={styles.textSpace}>
          <Text style={styles.partnerDetailSubtitle}>
            {t('prospectus-title-20')}
          </Text>
        </View>
      </View>
      <View style={styles.partnerDetailsHeader}>
        <Text style={styles.partnerDetailsHeaderText}>
          {t('before-the-event')}
        </Text>
        <Text style={styles.partnerDetailsHeaderText}>
          {t('at-the-live-event')}
        </Text>
        <Text style={styles.partnerDetailsHeaderText}>
          {t('after-the-event')}
        </Text>
      </View>
      <View style={styles.partnerDetailLineBar} />

      <View style={styles.partnerDetailsBodyWrapper}>
        <View style={styles.keyTopicsColumn}>
          <View style={styles.partnerDetailsItem}>
            <Text
              style={{
                ...stylesAwesome.icon,
                fontSize: 8,
                paddingTop: 3,
              }}
            >
              {'\uf0da'}
            </Text>
            <Text style={styles.partnerDetailsBody}>
              Bei we.CONECT Events beinhaltet das Partnering, Sie mit den
              richtigen Entscheidern zusammen zu bringen – maßgeschneidert zu
              Ihren Lösungen und Bedürfnissen.
            </Text>
          </View>
        </View>
        <View style={styles.keyTopicsColumn}>
          <View style={styles.partnerDetailsItem}>
            <Text style={{ ...stylesAwesome.icon, fontSize: 8, paddingTop: 3 }}>
              {'\uf0da'}
            </Text>
            <Text style={styles.partnerDetailsBody}>
              Bei we.CONECT Events beinhaltet das Partnering, Sie mit den
              richtigen Entscheidern zusammen zu bringen – maßgeschneidert zu
              Ihren Lösungen und Bedürfnissen.
            </Text>
          </View>
        </View>
        <View style={styles.keyTopicsColumn}>
          <View style={styles.partnerDetailsItem}>
            <Text style={{ ...stylesAwesome.icon, fontSize: 8, paddingTop: 3 }}>
              {'\uf0da'}
            </Text>
            <Text style={styles.partnerDetailsBody}>
              Bei we.CONECT Events beinhaltet das Partnering, Sie mit den
              richtigen Entscheidern zusammen zu bringen – maßgeschneidert zu
              Ihren Lösungen und Bedürfnissen.
            </Text>
          </View>
        </View>
      </View>
      <View style={styles.partnerDetailsFooter}>
        <Text style={styles.partnerDetailsFooterPrice}>3.990 €</Text>
        <Text
          style={{
            ...styles.bookNowButton,
            backgroundColor: event?.design?.themeColor,
          }}
        >
          {t('book-now')}
        </Text>
      </View>
    </View>
  );
};

export default PartnerDetails;
